// src/styles/dataTableStyles.js
export const customStyles = {
    headRow: {
        style: {
          backgroundColor: "#f5f6fa", // Change this color as needed
          color: "#ffffff",
          fontSize: "13px",
          fontWeight: "bold",
        },
      },
  };
  